var url_app="//www.east-material.com/apps/store-locator"; var store_render = "W3siaWQiOjE4MDQ3NywibmFtZSI6IlpoZW5nemhvdSBFYXN0IE1hdGVyaWFsIENvLC5MdGQuIiwidGh1bWJuYWlsIjoiIiwidXJsIjoiXC9hcHBzXC9zdG9yZS1sb2NhdG9yXC96aGVuZ3pob3UtZWFzdC1tYXRlcmlhbC1jby1sdGQuaHRtbCIsImFkZHJlc3MiOiJJbmR1c3RyaWFsIFBhcmssIERlbmdmZW5nLCBIZW5hbiwgNDUyNDcwLCBDaGluYSIsInBob25lIjpudWxsLCJlbWFpbCI6ImluZm9AZWFzdC1tYXRlcmlhbC5jb20iLCJ3ZWIiOm51bGwsInRhZ3MiOltdLCJkaXN0YW5jZSI6bnVsbCwibGF0IjoiMzQuNDU0NDQzMCIsImxuZyI6IjExMy4wNTA1ODEwIn1d";var tags_render = "IiI=";var products_render = "IiI=";var map_style_render = "W10=";var html_render = "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";var radius_default = "20";var radius_unit = "1";
!(function(){

  /* Load Script function we may need to load jQuery from the Google's CDN */

  /* That code is world-reknown. */

  /* One source: http://snipplr.com/view/18756/loadscript/ */

  

  var loadScript = function(url, callback){

    var script = document.createElement("script");

    script.type = "text/javascript";

    // If the browser is Internet Explorer.

    if (script.readyState){ 

      script.onreadystatechange = function(){

        if (script.readyState == "loaded" || script.readyState == "complete"){

          script.onreadystatechange = null;

          callback();

        }

      };

    // For any other browser.

    } else {

      script.onload = function(){

      callback();

      };

    }

    script.src = url;

    document.getElementsByTagName("head")[0].appendChild(script);

  };



  /* This is my app's JavaScript */

  var ndnappsStoreLocatorJavaScript = function(jQuery){

    var B64={alphabet:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",lookup:null,ie:/MSIE /.test(navigator.userAgent),ieo:/MSIE [67]/.test(navigator.userAgent),encode:function(a){var e,f,g,b=B64.toUtf8(a),c=-1,d=b.length,h=[,,];if(B64.ie){for(var i=[];++c<d;)e=b[c],f=b[++c],h[0]=e>>2,h[1]=(3&e)<<4|f>>4,isNaN(f)?h[2]=h[3]=64:(g=b[++c],h[2]=(15&f)<<2|g>>6,h[3]=isNaN(g)?64:63&g),i.push(B64.alphabet.charAt(h[0]),B64.alphabet.charAt(h[1]),B64.alphabet.charAt(h[2]),B64.alphabet.charAt(h[3]));return i.join("")}for(var i="";++c<d;)e=b[c],f=b[++c],h[0]=e>>2,h[1]=(3&e)<<4|f>>4,isNaN(f)?h[2]=h[3]=64:(g=b[++c],h[2]=(15&f)<<2|g>>6,h[3]=isNaN(g)?64:63&g),i+=B64.alphabet[h[0]]+B64.alphabet[h[1]]+B64.alphabet[h[2]]+B64.alphabet[h[3]];return i},decode:function(a){if(a.length%4)throw new Error("InvalidCharacterError: 'B64.decode' failed: The string to be decoded is not correctly encoded.");var b=B64.fromUtf8(a),c=0,d=b.length;if(B64.ieo){for(var e=[];d>c;)b[c]<128?e.push(String.fromCharCode(b[c++])):b[c]>191&&b[c]<224?e.push(String.fromCharCode((31&b[c++])<<6|63&b[c++])):e.push(String.fromCharCode((15&b[c++])<<12|(63&b[c++])<<6|63&b[c++]));return e.join("")}for(var e="";d>c;)e+=b[c]<128?String.fromCharCode(b[c++]):b[c]>191&&b[c]<224?String.fromCharCode((31&b[c++])<<6|63&b[c++]):String.fromCharCode((15&b[c++])<<12|(63&b[c++])<<6|63&b[c++]);return e},toUtf8:function(a){var d,b=-1,c=a.length,e=[];if(/^[\x00-\x7f]*$/.test(a))for(;++b<c;)e.push(a.charCodeAt(b));else for(;++b<c;)d=a.charCodeAt(b),128>d?e.push(d):2048>d?e.push(192|d>>6,128|63&d):e.push(224|d>>12,128|63&d>>6,128|63&d);return e},fromUtf8:function(a){var c,b=-1,d=[],e=[,,];if(!B64.lookup){for(c=B64.alphabet.length,B64.lookup={};++b<c;)B64.lookup[B64.alphabet.charAt(b)]=b;b=-1}for(c=a.length;++b<c&&(e[0]=B64.lookup[a.charAt(b)],e[1]=B64.lookup[a.charAt(++b)],d.push(e[0]<<2|e[1]>>4),e[2]=B64.lookup[a.charAt(++b)],64!=e[2])&&(d.push((15&e[1])<<4|e[2]>>2),e[3]=B64.lookup[a.charAt(++b)],64!=e[3]);)d.push((3&e[2])<<6|e[3]);return d}};

    var replacer = function(finder, element, blackList) {
      if (!finder) {
        return
      }

      var regex = (typeof finder == 'string') ? new RegExp(finder, 'g') : finder;
      var regex2 = (typeof finder == 'string') ? new RegExp(finder, 'g') : finder;

      var childNodes = element.childNodes;

      var len = childNodes.length;

      var list = typeof blackList == 'undefined' ? 'html,head,style,title,link,meta,script,object,iframe,pre,a,' : blackList ;

      while (len--) {
        var node = childNodes[len];

        if (node.nodeType === 1 && true || (list.indexOf(node.nodeName.toLowerCase()) === -1)) {
          replacer(finder, node, list);
        }
        if (node.nodeType !== 3 || !regex.test(node.data)) {
          continue;
        }
        var frag = (function(){
          var wrap = document.createElement('span');
          var frag = document.createDocumentFragment();
          var sliderId = regex2.exec(node.data)[1];
          wrap.innerHTML = '<div class="ndnapps-storelocator-shortcode" id="ndnapps-storelocator-shortcode"></div>';    
          while (wrap.firstChild) {
            frag.appendChild(wrap.firstChild);
          }    
          return frag;
        })();
        //console.log(frag);       
        var parent = node.parentNode;
        parent.insertBefore(frag, node);
        parent.removeChild(node);
      }
    };
    var storelocator_products_response = JSON.parse(B64.decode(products_render));

    var storelocator_tags_response = JSON.parse(B64.decode(tags_render));
    var html_reponse = B64.decode(html_render);

    //console.log(storelocator_tags_response);
   
   jQuery(document).ready(function () {
      var blackList;       
      jQuery('body').each(function(){
        replacer('\\[ndnapps-storelocator\\]', jQuery(this).get(0), blackList);            
      });
      jQuery('#ndnapps-storelocator-shortcode').html(html_reponse);
      jQuery('#tags').html(storelocator_tags_response);
      if(jQuery('.ndnapps-storelocator-equal').length){
        jQuery('#frm-storelocator-search .map_container').css("height",(jQuery('.ndnapps-storelocator-equal').outerHeight() + 540)+"px");
      } 
    // console.log(jQuery('#ndnapps-storelocator-index').length);
      if (jQuery('#ndnapps-storelocator-index').length) {
        // console.log('load');
        loadMap();
        if(jQuery("#map > div").length <= 0)
        google.maps.event.addDomListener(window, 'load', loadMap);

        jQuery('#radius_search').on("change mousemove", function () {
          jQuery('#radius-value .num-range').html(jQuery(this).val());
        });
        jQuery('.chose-search-slt').on("change", function () {
          if (jQuery(this).val() == 'location') {
            jQuery('.input-radius-slt').parent().show();
            jQuery('.gr-search-slt').show();
            //jQuery('.input-attribute-slt').hide();
            jQuery('#product_search').hide();
            jQuery('#store_search').hide();

          }
          if (jQuery(this).val() == 'product') {
            jQuery('.input-radius-slt').parent().hide();
            //jQuery('.input-attribute-slt').show();
            jQuery('#store_search').hide();
            jQuery('.gr-search-slt').hide();;
            jQuery('#product_search').show();

          }
          if (jQuery(this).val() == 'store') {
            jQuery('.input-radius-slt').parent().hide();
            //jQuery('.input-attribute-slt').show();
            jQuery('.gr-search-slt').hide();
            jQuery('#product_search').hide();
            jQuery('#store_search').show();

          }
        });
        //jQuery('#tags').html('<ul><li>'+tags+'</li></ul>');
      }

    });

    jQuery(document).on('change', '.ndnapp_stores_tags_filter', function(e){
    // jQuery('.ndnapp_stores_tags_filter').change(function (e) {
      e.preventDefault();
      if (jQuery('.chose-search-slt').val() == 'location') {
        if(jQuery('#frm-storelocator-search #address').val() != ''){
          searchLocation();
        }else{
         
          loadMap();
        }
      } 
      if (jQuery('.chose-search-slt').val() == 'product') {
        if(jQuery('#frm-storelocator-search #product_search').val() != ''){
          searchStoresByProducts();
        }else{
          loadMap();
        }
      }
      if (jQuery('.chose-search-slt').val() == 'store') {
        if(jQuery('#frm-storelocator-search #store_search').val() != ''){
          searchStoresByName();
        }else{
          loadMap();
        }
      }
    })
    // jQuery('#frm-storelocator-search').submit(function (e) {
    jQuery(document).on("submit","#frm-storelocator-search",function(e) {
      e.preventDefault();

      if (jQuery('.chose-search-slt').val() == 'location') {
        searchLocation();
      }
      if (jQuery('.chose-search-slt').val() == 'product') {
        searchStoresByProducts();
      }
      if (jQuery('.chose-search-slt').val() == 'store') {
        searchStoresByName();
      }

    });
    // jQuery('#frm-storelocator-search input').on('keydown', function (e) {
    jQuery(document).on("keydown","#frm-storelocator-search input",function(e) {
      if (e.which == 13) {
        e.preventDefault();
        jQuery("#frm-storelocator-search").trigger("submit");
      }
    });

    jQuery(document).on('click', '#reset-search', function (e) {
      e.preventDefault();
      // console.log('111');
      jQuery('#results-empty').html('<h5></h5>');
      jQuery('#address,#product_search').val('');
      jQuery('#radius_search').val(radius_default);
      jQuery('.num-range').html(radius_default);
      jQuery(".ndnapp_stores_tags_filter").prop("checked", false);
      loadMap();
    });
    jQuery(window).on('load',function () {
      jQuery('.chose-search-slt').val('location');
      jQuery('.input-radius-slt').show();
      jQuery('.gr-search-slt').show();
      jQuery('.input-attribute-slt').hide();
      jQuery('#product_search').hide();
    });
    jQuery(document).on('mouseover', '.inner-item', function () {
      onMouseover(jQuery(this).parent().attr("datamarker"));
    });
    jQuery(document).on('mouseout', '.inner-item', function () {
      onMouseover(jQuery(this).parent().attr("datamarker"));
    });

    jQuery(document).on('click', '.inner-item', function () {

      num = jQuery(this).parent().attr("datamarker");

      google.maps.event.trigger(markers[num], 'click');
    });
    jQuery(document).on('click', '#getbylocal', function () {
      initMap();
    });

    // function onMouseover(markerNum) {

    //     markers[markerNum].setAnimation(google.maps.Animation.BOUNCE);
    //     console.log(markers[markerNum]);
    //     setTimeout(function(){if (markers[markerNum].getAnimation() !== null) {markers[markerNum].setAnimation(null);} }, 750);
    // }
    function onMouseover(markerNum) {
      var currentIcon = markers[markerNum];
      currentIcon.setAnimation(null);

      if (currentIcon.getAnimation() != null) {
        currentIcon.setAnimation(null);
      } else {
        currentIcon.setAnimation(google.maps.Animation.BOUNCE);
        setTimeout(function () {
          currentIcon.setAnimation(null);
        }, 500);
      }
    }

    function onMouseout(markerNum) {
      markers[markerNum].setAnimation(null);
    }

    function initMap() {

      // Try HTML5 geolocation.

      if (navigator.geolocation) {

        navigator.geolocation.getCurrentPosition(function (position) {

          var geocoder = new google.maps.Geocoder();

          var latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);



          geocoder.geocode({

            'latLng': latlng

          }, function (results, status) {

            if (status == google.maps.GeocoderStatus.OK) {

              if (results[1]) {

                document.getElementById('address').value = results[1].formatted_address;

              } else {

                //alert(trans['no_result']); //"no_result"

                jQuery('#results-empty').html('<h5 class="alert alert-danger">'+trans['no_result'] +'</h5>');

              }

            } else {

              //alert(trans['geocoder_failed'] + status); //"geocoder_failed"

              jQuery('#results-empty').html('<h5 class="alert alert-danger">'+trans['geocoder_failed'] +'</h5>');

            }

          }.bind(this));



          // document.getElementById("latitude").value = position.coords.latitude;

          //            document.getElementById("longitude").value = position.coords.longitude;

        }.bind(this), function (error) {}.bind(this));

      }

    }
    function loadMap() {
      //initial_zoomtMap();
      document.getElementById("loading_mask_loader").style.display = 'block';
      var styledMapType = new google.maps.StyledMapType(JSON.parse(B64.decode(map_style_render)));
      map = new google.maps.Map(document.getElementById("map"), {
        center: new google.maps.LatLng(center_lat, center_lng),
        zoom: initial_zoom,
        mapTypeId: 'roadmap',
        mapTypeControl: false,
        mapTypeControlOptions: {
          style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
        }
      });
      map.mapTypes.set('styled_map', styledMapType);
      map.setMapTypeId('styled_map');
      infoWindow = new google.maps.InfoWindow();

      locationDiv = document.getElementById("location");
      input = document.getElementById('address');
      clearLocations();
      var bounds = new google.maps.LatLngBounds();
      var searchBox = new google.maps.places.SearchBox(input);
      var tags_input = [];
      jQuery.each(jQuery('input.ndnapp_stores_tags_filter:checked'), function() {
          tags_input.push(jQuery(this).val());
      });
      
      var searchUrl = url_app + '/all/ajax';//?all=1&shop=' + Shopify.shop;

        //var xml = parseXml(data);
        var markerNodes = JSON.parse(B64.decode(store_render));
        // console.log(markerNodes);
        jQuery("#results-empty").html('');

        var thum = '';
        var count_marker = 0;
        for (var i = 0; i < markerNodes.length; i++) {
          //console.log(markerNodes[i]);
 
          if( checkTag( tags_input, markerNodes[i]['tags'] ) ){
              if (typeof markerNodes[i]['thumbnail'] !== 'undefined') {
                thum = markerNodes[i]['thumbnail'];
              }
              var id = markerNodes[i]['id'];
              var name = markerNodes[i]['name'];
              var url = markerNodes[i]['url'];
              var address = markerNodes[i]['address'];
              var phone = markerNodes[i]['phone'];
              var email = markerNodes[i]['email'];
              var web = markerNodes[i]['web'];
              var distance = parseFloat(markerNodes[i]['distance']);
              var latlng = new google.maps.LatLng(
                parseFloat(markerNodes[i]['lat']),
                parseFloat(markerNodes[i]['lng']));
              var tags = markerNodes[i]['tags'];
              listItem(thum,latlng, id, name, url, address, phone, email, web, distance, tags, count_marker - 1);
              createMarker(id, latlng, name, thum, url, address, phone, email, web, tags, count_marker);
              bounds.extend(latlng);
              count_marker++;
          }
        }

        if (count_marker == 0) {
          jQuery("#results-empty").html('<h5 class="alert alert-danger">'+trans['no_store'] +'</h5>');
          jQuery("#results-slt").hide();
          document.getElementById("loading_mask_loader").style.display = 'none';
          return;
        }
        jQuery("#results-slt").show();
        document.getElementById("loading_mask_loader").style.display = 'none';
        if(count_marker > 1){
          jQuery("#ndn-text-result").text(jQuery("#ndn-text-result").data('results'));
          // console.log(jQuery("#ndn-text-result").data('results'));
        }else{
          // console.log(jQuery("#ndn-text-result").data('result'));
          jQuery("#ndn-text-result").text(jQuery("#ndn-text-result").data('result'));
        }
        document.getElementById("num-rs").innerHTML = count_marker;
        map.fitBounds(bounds);
        if(center_lat == 0 && center_lng == 0){
          var zoom = map.getZoom();
          zoom = Math.min(zoom, 12);
          map.setZoom(zoom);
        }else{
          var listener = google.maps.event.addListener(map, "idle", function() { 
            map.setZoom(initial_zoom);
            map.setCenter(new google.maps.LatLng(center_lat, center_lng)); 
            google.maps.event.removeListener(listener); 
          });
        }
        

        document.getElementById("loading_mask_loader").style.display = 'none';
        //console.log(markerNodes.length >= 4 && layout == 1);
        if (markerNodes.length >= 4 && layout == 1) {
          jQuery('#main-slider-storelocator').addClass(owl_class);
          jQuery('#main-slider-storelocator').remove('list-item-3');
          jQuery("#main-slider-storelocator").owlCarousel({
            loop: true,
            margin: 10,
            nav: true,
            responsive: {
              0: {
                items: 1
              },
              600: {
                items: 3
              },
              1000: {
                items: 3
              }
            }
          });
        }
     
      
    }

        /**
     * Converts degrees to radians.
     * 
     * @param degrees Number of degrees.
     */
    function degreesToRadians(degrees){
        return degrees * Math.PI / 180;
    }

    function getDistanceBetweenPoints(lat1, lng1, lat2, lng2){
        // The radius of the planet earth in meters
        let R = 6378137;
        let dLat = degreesToRadians(lat2 - lat1);
        let dLong = degreesToRadians(lng2 - lng1);
        let a = Math.sin(dLat / 2)
                *
                Math.sin(dLat / 2) 
                +
                Math.cos(degreesToRadians(lat1)) 
                * 
                Math.cos(degreesToRadians(lat1)) 
                *
                Math.sin(dLong / 2) 
                * 
                Math.sin(dLong / 2);

        let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        let distance = R * c;

        return distance;
    }
    function superbag(sup, sub) {
        if(sup.length < sub.length)
          return false;
        sup.sort();
        sub.sort();
        var i, j;
        for (i=0,j=0; i<sup.length && j<sub.length;) {

            if (sup[i] < sub[j]) {
                ++i;
            } else if (sup[i] == sub[j]) {
                ++i; ++j;
            } else {
                // sub[j] not in sup, so sub not subbag
                return false;
            }
        }
        // make sure there are no elements left in sub
        
        if (j<sub.length)
          return false;
         else
            return true;
         
    }
    function diff(arr1, arr2) {
      var filteredArr1 = arr1.filter(function(ele) {
        return arr2.indexOf(ele) == -1;
      });

      var filteredArr2 = arr2.filter(function(ele) {
        return arr1.indexOf(ele) == -1;
      });
      // console.log(filteredArr1);
      // console.log(filteredArr2);
      return filteredArr1.concat(filteredArr2);
    }
    /*
    function checkDistanceBetweenPoints(lat1, lng1, lat2, lng2, radius, dv = 0.001){
        var check = -1;
        if(getDistanceBetweenPoints(lat1, lng1, lat2, lng2)*dv <= radius )
          check = getDistanceBetweenPoints(lat1, lng1, lat2, lng2)*dv;
        return check;
    }*/
    /*Fix for IE*/
      function checkDistanceBetweenPoints(lat1, lng1, lat2, lng2, radius) {
      var dv = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0.001;
      var check = -1;
      if (getDistanceBetweenPoints(lat1, lng1, lat2, lng2) * dv <= radius) 
        check = getDistanceBetweenPoints(lat1, lng1, lat2, lng2) * dv;
      return check;
    }
    /**/
    function checkTag(tag,tags){
      var check = 0;
     
      if(tag.length == 0 || superbag(tags, tag) == true)
        check =1;
      return check;
    }

    function searchLocation() {

      document.getElementById("loading_mask_loader").style.display = '';

      var address = document.getElementById("address").value;
      var radius_search = document.getElementById("radius_search").value;

      var checkboxes = document.getElementsByName('stores_tags_filter[]');
      var vals = "";
      for (var i=0, n=checkboxes.length;i<n;i++) 
      {
          if (checkboxes[i].checked) 
          {
              vals += ","+checkboxes[i].value;
          }
      }
      if ((address == '' || address == null) && vals == "") {
        //alert(trans['please_enter']);
        jQuery('#address').focus();
        document.getElementById("loading_mask_loader").style.display = 'none';
        return false;
      }
      if ((radius_search == '' || radius_search == null) && vals == "") {
        //alert('Please enter a radius.');
        document.getElementById("loading_mask_loader").style.display = 'none';
        return false;
      }
      
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({
        address: address
      }, function (results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          var latlng = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
          var marker = new google.maps.Marker({
            map: map,
            position: latlng,
            icon: 'http://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|6fba33'
          });
          markers.push(marker);
          clearLocations();
          searchLocationsNear(results[0].geometry.location);
        } else {
          document.getElementById("loading_mask_loader").style.display = 'none';
          map.setZoom(initial_zoom);
          //alert(address + trans['address_null']);
          //if(vals == "")
          jQuery('#results-empty').html('<h5 class="alert alert-danger"><i>'+ address +'</i>'+ trans['address_null']+'</h5>');
          
        }

      });
    }

    function searchStoresByProducts() {

      var bounds = new google.maps.LatLngBounds();
      document.getElementById("loading_mask_loader").style.display = '';
      var search_text = document.getElementById("product_search").value;

      clearLocations();
      var tags = [];
      jQuery.each(jQuery('input.ndnapp_stores_tags_filter:checked'), function() {
          tags.push(jQuery(this).val());
      });
      var data = {name:search_text,shop: Shopify.shop,tags:tags.join(',')};

      var searchUrl = url_app + '/all/searchproduct';//?name=' + search_text + '&shop=' + Shopify.shop;
      jQuery.ajaxSetup({
        headers: {
          'X-CSRF-TOKEN': jQuery('input[name="_token"]').val()
        }
      });
      jQuery.ajax({
        url: searchUrl,
        type: "GET",
        data: data,
        cache: false,
        dataType: "json",
      }).done(function (data) {

        var markerNodes = data.data;
        
        if (markerNodes.length == 0) {

          document.getElementById("loading_mask_loader").style.display = 'none';
          document.getElementById("results-slt").style.display = 'none';
          var query_search = document.getElementById("product_search").value;
          //alert('There is no store contain product name is: ' + query_search);
          jQuery('#results-empty').html('<h5 class="alert alert-danger">'+trans['no_store_product'] +' <i>"'+ query_search+'"</i></h5>');
          
          return;
        }
        document.getElementById("results-slt").style.display = 'block';
        var thum = '';
        if(markerNodes.length > 1){
          jQuery("#ndn-text-result").text(jQuery("#ndn-text-result").data('results'));
          // console.log(jQuery("#ndn-text-result").data('results'));
        }else{
          // console.log(jQuery("#ndn-text-result").data('result'));
          jQuery("#ndn-text-result").text(jQuery("#ndn-text-result").data('result'));
        }
        document.getElementById("num-rs").innerHTML = markerNodes.length;
        for (var i = 0; i < markerNodes.length; i++) {
          //console.log(markerNodes[i]);
          if (typeof markerNodes[i]['thumbnail'] !== 'undefined') {
            thum = markerNodes[i]['thumbnail'];
          }
          var id = markerNodes[i]['id'];
          var name = markerNodes[i]['name'];
          var url = markerNodes[i]['url'];
          var address = markerNodes[i]['address'];
          var phone = markerNodes[i]['phone'];
          var email = markerNodes[i]['email'];
          var web = markerNodes[i]['web'];
          var distance = parseFloat(markerNodes[i]['distance']);
          var latlng = new google.maps.LatLng(
            parseFloat(markerNodes[i]['lat']),
            parseFloat(markerNodes[i]['lng']));
          var tags =  markerNodes[i]['tags'];
          // console.log(tags);
          listItem(thum,latlng, id, name, url, address, phone, email, web, distance, tags, i - 1);
          createMarker(id, latlng, name, thum, url, address, phone, email, web, tags, i);
          bounds.extend(latlng);
        }

        map.fitBounds(bounds);
        var zoom = map.getZoom();
        zoom = Math.min(zoom, 12);
        map.setZoom(zoom);

        document.getElementById("loading_mask_loader").style.display = 'none';
        if (markerNodes.length >= 4 && layout == 1) {
          jQuery('#main-slider-storelocator').addClass('owl-carousel owl-theme');
          jQuery('#main-slider-storelocator').remove('list-item-3');
          jQuery("#main-slider-storelocator").owlCarousel({
            loop: true,
            margin: 10,
            nav: true,
            responsive: {
              0: {
                items: 1
              },
              600: {
                items: 3
              },
              1000: {
                items: 3
              }
            }
          });
        }
      }).fail(function () {
        window.location.href = '/';
      });
      // }        
      return true;
    }
    function searchStoresByName() {

      var bounds = new google.maps.LatLngBounds();
      document.getElementById("loading_mask_loader").style.display = '';
      var search_text = document.getElementById("store_search").value;

      clearLocations();
      var tags = [];
      jQuery.each(jQuery('input.ndnapp_stores_tags_filter:checked'), function() {
          tags.push(jQuery(this).val());
      });
      var data = {name:search_text,shop: Shopify.shop,tags:tags.join(',')};

      var searchUrl = url_app + '/all/searchbyname';//?name=' + search_text + '&shop=' + Shopify.shop;
      jQuery.ajaxSetup({
        headers: {
          'X-CSRF-TOKEN': jQuery('input[name="_token"]').val()
        }
      });
      jQuery.ajax({
        url: searchUrl,
        type: "GET",
        data: data,
        cache: false,
        dataType: "json",
      }).done(function (data) {

        var markerNodes = data.data;
        
        if (markerNodes.length == 0) {

          document.getElementById("loading_mask_loader").style.display = 'none';
          document.getElementById("results-slt").style.display = 'none';
          var query_search = document.getElementById("store_search").value;
          //alert('There is no store contain product name is: ' + query_search);
          jQuery('#results-empty').html('<h5 class="alert alert-danger">'+trans['no_store_name'] +' <i>"'+ query_search+'"</i></h5>');
          
          return;
        }
        document.getElementById("results-slt").style.display = 'block';
        var thum = '';
        if(markerNodes.length > 1){
          jQuery("#ndn-text-result").text(jQuery("#ndn-text-result").data('results'));
          // console.log(jQuery("#ndn-text-result").data('results'));
        }else{
          // console.log(jQuery("#ndn-text-result").data('result'));
          jQuery("#ndn-text-result").text(jQuery("#ndn-text-result").data('result'));
        }
        document.getElementById("num-rs").innerHTML = markerNodes.length;
        for (var i = 0; i < markerNodes.length; i++) {
          //console.log(markerNodes[i]);
          if (typeof markerNodes[i]['thumbnail'] !== 'undefined') {
            thum = markerNodes[i]['thumbnail'];
          }
          var id = markerNodes[i]['id'];
          var name = markerNodes[i]['name'];
          var url = markerNodes[i]['url'];
          var address = markerNodes[i]['address'];
          var phone = markerNodes[i]['phone'];
          var email = markerNodes[i]['email'];
          var web = markerNodes[i]['web'];
          var distance = parseFloat(markerNodes[i]['distance']);
          var latlng = new google.maps.LatLng(
            parseFloat(markerNodes[i]['lat']),
            parseFloat(markerNodes[i]['lng']));
          var tags =  markerNodes[i]['tags'];
          // console.log(tags);
          listItem(thum,latlng, id, name, url, address, phone, email, web, distance, tags, i - 1);
          createMarker(id, latlng, name, thum, url, address, phone, email, web, tags, i);
          bounds.extend(latlng);
        }

        map.fitBounds(bounds);
        var zoom = map.getZoom();
        zoom = Math.min(zoom, 12);
        map.setZoom(zoom);

        document.getElementById("loading_mask_loader").style.display = 'none';
        
      }).fail(function () {
        window.location.href = '/';
      });
      // }        
      return true;
    }
    function searchLocationsNear(center) {
      var bounds = new google.maps.LatLngBounds();
      bounds.extend(center);
      map.setCenter(new google.maps.LatLng(center.lat(), center.lng()));
      map.setZoom(search_result_zoom);
      
      var radius = document.getElementById('radius_search').value;
      //var searchUrl = baseurl + 'all/ajax?lat=' + center.lat() + '&lng=' + center.lng() + '&radius=' + radius + '&shop=' + Shopify.shop;
      var searchUrl = url_app + '/all/ajax';//?lat=' + center.lat() + '&lng=' + center.lng() + '&radius=' + radius + '&radius=' + Shopify.shop;
      var tags_check = [];
      jQuery.each(jQuery('input.ndnapp_stores_tags_filter:checked'), function() {
          tags_check.push(jQuery(this).val());
      });
      var data = {lat:center.lat(),lng:center.lng(),radius:radius,shop: Shopify.shop,tags:tags_check.join(',')};
     

        var markerNodes = JSON.parse(B64.decode(store_render));
        var marker_count = 0;
        var dv = 1;
        if(radius_unit == 1 ){
            dv = 0.001; 
        }else{
            dv= 0.00062137;
        }
        var array_poin = [];
        for (var i = 0; i < markerNodes.length; i++) {
            // console.log( markerNodes[i]['tags'] );

            var distance = checkDistanceBetweenPoints(center.lat(),center.lng(),markerNodes[i]['lat'],markerNodes[i]['lng'],radius,dv)
            if( distance > -1 && checkTag(tags_check , markerNodes[i]['tags']) ){
              if (typeof markerNodes[i]['thumbnail'] !== 'undefined') {
                thum = markerNodes[i]['thumbnail'];
              }
              var id = markerNodes[i]['id'];
              var name = markerNodes[i]['name'];
              var url = markerNodes[i]['url'];
              var address = markerNodes[i]['address'];
              var phone = markerNodes[i]['phone'];
              var email = markerNodes[i]['email'];
              var web = markerNodes[i]['web'];
              // var distance = parseFloat(markerNodes[i]['distance']);
              var latlng = new google.maps.LatLng(
                parseFloat(markerNodes[i]['lat']),
                parseFloat(markerNodes[i]['lng']));
              var tags = markerNodes[i]['tags'];
              array_poin[i] = {latlng:latlng,thum:thum, id:id, name:name, url:url, address:address, phone:phone, email:email, web:web, distance:distance, tags:tags, marker_count:marker_count};
             
              marker_count++;
            }
        }
        if(marker_count > 0 ){
            array_poin = array_poin.sort(function (a, b) {
            return a.distance - b.distance ;
            });
            for (var i = 0; i < marker_count; i++) {
              listItem(array_poin[i].thum,array_poin[i].latlng, array_poin[i].id, array_poin[i].name, array_poin[i].url, array_poin[i].address, array_poin[i].phone, array_poin[i].email, array_poin[i].web, array_poin[i].distance, array_poin[i].tags, i - 1);
                createMarker(array_poin[i].id, array_poin[i].latlng, array_poin[i].name, array_poin[i].thum, array_poin[i].url, array_poin[i].address, array_poin[i].phone, array_poin[i].email, array_poin[i].web, array_poin[i].tags, i,array_poin[i].distance); 
                bounds.extend(array_poin[i].latlng);
            }
        }
        if (marker_count == 0) {

          document.getElementById("loading_mask_loader").style.display = 'none';
          document.getElementById("results-slt").style.display = 'none';
          var address = document.getElementById("address").value;
          //alert(trans['store_near'] + address); //"store_near"
          jQuery('#results-empty').html('<h5 class="alert alert-danger">'+trans['store_near'] +'<i>"'+ address+'"</i></h5>');
          return;
        }

        jQuery('#results-empty').html('<h5></h5>');
        document.getElementById("results-slt").style.display = 'block';
        var thum = '';
        if(marker_count > 1){
          jQuery("#ndn-text-result").text(jQuery("#ndn-text-result").data('results'));
          // console.log(jQuery("#ndn-text-result").data('results'));
        }else{
          // console.log(jQuery("#ndn-text-result").data('result'));
          jQuery("#ndn-text-result").text(jQuery("#ndn-text-result").data('result'));
        }
        document.getElementById("num-rs").innerHTML = marker_count;

        map.fitBounds(bounds);
        var zoom = map.getZoom();
        zoom = Math.min(zoom, 12);
        map.setZoom(zoom);

        document.getElementById("loading_mask_loader").style.display = 'none';
        if (markerNodes.length >= 4 && layout == 1) {
          jQuery('#main-slider-storelocator').addClass('owl-carousel owl-theme');
          jQuery('#main-slider-storelocator').remove('list-item-3');
          jQuery("#main-slider-storelocator").owlCarousel({
            loop: true,
            margin: 10,
            nav: true,
            responsive: {
              0: {
                items: 1
              },
              600: {
                items: 3
              },
              1000: {
                items: 3
              }
            }
          });
        }
      

    }



    function clearLocations() {
      infoWindow.close();
      for (var i = 0; i < markers.length; i++) {
        markers[i].setMap(null);
      }
      //console.log(markers.length);
      markers.length = 0;
      // randomID = guRandomid();
      if (locationDiv) locationDiv.innerHTML = '<div id="' + randomID + '" class="list-item-3"></div>';
    }
    
  function createMarker(store_id, latlng, name, thum, url, address, phone, email, web, tags, num) {
      var distance = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : null;
      var html = '';
      
      html += '<div class="store-marker">';
      html += '<div class="address-info"><div class="table-store-marker">';
      html += '<div class="row">';
      html += '<label class="col-md-12">' + name + '</label>';
      if (thum){
        html += '<div class="col-md-4"><img src="' + thum + '"></div>';
        html += '<div class="col-md-8">';
      }
      else
        html += '<div class="col-md-12">';
      //html += '<tr><td><strong>' + trans['address'] + ':</strong></td><td><p>' + address + '</p></td></tr>';
      html += '<p><strong><i class="fa fa-map-marker" aria-hidden="true"></i></strong> ' + address + '</p>';
      if(distance) {
        //html += '<label>' + trans['web'] + ': </label>';
        var radius_unit_text = ' Km'; 
        if(radius_unit != 1)
         radius_unit_text = ' mi'; 
        html += '<p><strong><i class="fa fa-road" aria-hidden="true"></i></strong>' + distance.toFixed(2) + radius_unit_text + '</p>';
      }
      if (email !== null) {
        html += '<p><strong><i class="fa fa-envelope" aria-hidden="true"></i></strong> <a href="mailto:' + email + '">' + email + '</a></p>';
      }
      if (phone !== null) {
        html += '<p><strong><i class="fa fa-phone" aria-hidden="true"></i></strong> <a href="tel:' + phone + '">' + phone + '</a></p>';
      }
      if (web !== null) {
        html += '<p><strong><i class="fa fa-link" aria-hidden="true"></i></strong> '+web+'</p>';
      }
      if (tags.length > 0) {
        //html += '<label>' + trans['web'] + ': </label>';
        var tag_arr = tags;
        var tag_html = '';
        jQuery.each( tag_arr, function( key, value ) {
          tag_html += '<span class="tag-item"><i class="fa fa-check" aria-hidden="true"></i>'+value+ '</span>'; 
        });
        html += '<p><strong><i class="fa fa-tags" aria-hidden="true"></i></strong> '+tag_html+'</p>';
      }
      if (url !== null) {
        html += '<a class="linkdetailstore" href="' + url + '">' + trans['link_detail'] + ' <i class="fa fa-long-arrow-right" aria-hidden="true"></i></a>';
      }
      html += '<a class="getdirectionstore" href="https://maps.google.com/?daddr=' + address + '" target="_blank">' + trans['getdirection'] + ' <i class="fa fa-long-arrow-right" aria-hidden="true"></i></a></div></div>';

      html += '<div id="'+store_id+'"></div>';
      html += '</div></div></div></div>';

      //console.log(window.icon_marker);
      if(window.icon_marker != ''){
        var icon = {
          url: window.icon_marker, // url
          scaledSize: new google.maps.Size(40, 40), // scaled size
          // origin: new google.maps.Point(0,0), // origin
          // anchor: new google.maps.Point(0, 0) // anchor
        };
        var marker = new google.maps.Marker({
          map: map,
          position: latlng,
          // label: {
          //  text: String(num + 1),
          //  color: 'white',
          //  fillColor:'black'
          // },
          store_id: "store_id_" + (num + 1),
          icon: icon//'http://chart.apis.google.com/chart?chst=d_map_pin_letter_withshadow&chld=' + (num + 1) + '|7e33ba'  
        });
      }else{
        var marker = new google.maps.Marker({
          map: map,
          position: latlng,
//          label: {
//            text: String(num + 1),
//            color: 'white'
//          },
          store_id: "store_id_" + (num + 1),
           
        });
      }
      google.maps.event.addListener(marker, 'click', function () {

        infoWindow.setContent(html);
        infoWindow.open(map, marker);
        if (layout != 1) {

          var divScrollTop = jQuery('#main-slider-storelocator').scrollTop();
          var divWindow = jQuery('#main-slider-storelocator').offset().top+5;
          var clickedLink = jQuery("#" + marker.store_id).offset().top;
          //toScroll += clickedLink - divWindow;
          jQuery("#main-slider-storelocator .inner-item").css( "background","none");
          jQuery("#"+marker.store_id).css( "background","#f2f2f2");
          jQuery('#main-slider-storelocator').animate({
            scrollTop: clickedLink - divWindow + divScrollTop
          }, 100);
        }

      });
      markers.push(marker);
    }

    function listItem(thum,latlng, id, name, url, address, phone, email, web, distance, tags, num) {
      num = num + 1;

      element = document.createElement("div");
      if (typeof distance !== 'undefined') {
        var att = document.createAttribute("datamarker");
        att.value = num;
        element.setAttributeNode(att);

        // att = document.createAttribute("onmouseout");
        // att.value = "onMouseout(" + num + ")";
        // element.setAttributeNode(att); 
      }
      var att = document.createAttribute('class');
      att.value = "item thumbnail";
      element.setAttributeNode(att);
      var html = '<div class="inner-item" id="store_id_' + (num + 1) + '">';
      if (thum) {
        html += '<div class="item-thumb"><img title="" src="' + thum + '"></div>';
      } else {
        html += '<div class="item-thumb"></div>';
      }
      html += '<div class="item-content"><label><strong>' + name + '</strong></label>';
      // element.innerHTML += '<div class="clear"></div>';
      html += '<div class="address"><label><i class="fa fa-map-marker" aria-hidden="true"></i> </label>' + address + '</div>';
      if (distance) {
        //html += '<label>' + trans['web'] + ': </label>';
        var radius_unit_text = ' Km'; 
        if(radius_unit != 1)
          radius_unit_text = ' m'; 
        html += '<label><i class="fa fa-road" aria-hidden="true"></i></label>';
        html +=  distance.toFixed(2) +radius_unit_text+'<br/>';
      }
      if (email !== null) {
        //html += '<label>' + trans['email'] + ': </label>';
        html += '<label><i class="fa fa-envelope" aria-hidden="true"></i></label>';
        html += '<a href="mailto:' + email + '" class="phone-email">' + email + '</a><br/>';
      }
      if (phone !== null) {
        //html += '<label>' + trans['phone'] + ': </label>';
        html += '<label><i class="fa fa-phone" aria-hidden="true"></i></label>';
        html += '<a href="tel:' + phone + '" class="phone-no">' + phone + '</a><br/>';
      }
      if (web !== null) {
        //html += '<label>' + trans['web'] + ': </label>';
        html += '<label><i class="fa fa-link" aria-hidden="true"></i></label>';
        html +=  web +'<br/>';
      }
      
      // if (tags != null) {
      //  //html += '<label>' + trans['web'] + ': </label>';
      //  var tag_arr = tags.split(",");
      //  var tag_html = '';
      //  jQuery.each( tag_arr, function( key, value ) {
      //    tag_html += '<span class="tag-item"><i class="fa fa-check" aria-hidden="true"></i>'+value+ '</span>'; 
      //  });
      //  html += '<label><i class="fa fa-tags" aria-hidden="true"></i></label>';
      //  html += '<div class="tags-list">' + tag_html + '</div><br/>';
      // }
      //"link_detail"
      if (url !== null) {
        html += '<a class="linkdetailstore" href="' + url + '">' + trans['link_detail'] + ' <i class="fa fa-long-arrow-right" aria-hidden="true"></i></a>';
      }
      html += '<a class="getdirectionstore" href="https://maps.google.com/?daddr=' + address + '" target="_blank">' + trans['getdirection'] + ' <i class="fa fa-long-arrow-right" aria-hidden="true"></i></a></div></div>';

      html += '</div>';
      element.innerHTML += html;

      document.getElementById(randomID).appendChild(element);
    }



    jQuery(document).ready(function () {

      

      if (jQuery('#ndn-contactForm').length) {

        jQuery('#ndn-contactForm').submit(function (e) {

          e.preventDefault();

          var searchUrl = ndn_detail.action;

          jQuery.ajaxSetup({

            headers: {

              'X-CSRF-TOKEN': jQuery('input[name="_token"]').val()

            }

          });

          jQuery.ajax({

            url: searchUrl,

            type: "POST",

            data: jQuery(this).serialize(),

            cache: false,

            dataType: "json",

          }).done(function (data) {

            if (data.error) {

              console.log(typeof (data.mess));

              if (typeof (data.mess) != 'object') {

                jQuery('.ndn-alert').html(data.mess);

              } else {

                var err_ul = '<ul class="ndn-errors">';

                jQuery.each(data.mess, function (key, value) {



                  err_ul += '<li id="err-' + key + '">-' + value + '</li>';

                  jQuery('#' + key).addClass('input-err');

                });

                err_ul += '</ul>';

                jQuery('.ndn-alert').html(err_ul);

              }



              jQuery('.ndn-alert').show();

            } else {

              jQuery('#ndn-storeloctor-contactFrm .ndn-success').html(data.mess);
              jQuery('#ndn-storeloctor-contactFrm .ndn-storelocator-hidden').css("visibility","hidden"); 
              jQuery('.ndn-alert').hide();
              // jQuery('#ndn-storeloctor-contactFrm').hide();

              jQuery('#ndn-storeloctor-contactFrm input,#ndn-storeloctor-contactFrm .field__input').removeClass('input-err');
              jQuery('#ndn-storeloctor-contactFrm .ndn-success').show();
              setTimeout(function() { 
                jQuery('#ndn-storeloctor-contactFrm .ndn-storelocator-hidden').css("visibility","visible"); 
                jQuery('#ndn-storeloctor-contactFrm .ndn-success').hide(); 
                jQuery('#ndn-storeloctor-contactFrm .field__input').val('');
              }, 5000);

            }

          });



        });



      }

    });
  };

  /* If jQuery has not yet been loaded or if it has but it's too old for our needs,

  we will load jQuery from the Google CDN, and when it's fully loaded, we will run

  our app's JavaScript. Set your own limits here, the sample's code below uses 1.7

  as the minimum version we are ready to use, and if the jQuery is older, we load 1.9.

  //ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js

  */

  
  function isMyScriptLoaded() {
    var scripts = document.getElementsByTagName('script');
    for (var i = scripts.length; i--;) {
      //if (scripts[i].src == url) return true;
      if (scripts[i].innerText.indexOf('asyncLoad') >= 0 && scripts[i].innerText.indexOf("app.20190227.js") >= 0) {
        console.log('already has scripttag Ndnapps file js');
        return true
      }
    }
    return false;
  }
  if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {

    loadScript('//code.jquery.com/jquery-1.11.1.min.js', function(){

      NDNAPPS = jQuery.noConflict(true);

      NDNAPPS(document).ready(function() {
          if (isMyScriptLoaded()) {
            ndnappsStoreLocatorJavaScript(NDNAPPS);
          }

      });

  });

  } else {
      if (isMyScriptLoaded()) {
        ndnappsStoreLocatorJavaScript(jQuery);
      }
  }

})();